const faq = () => ({
  faqPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/faqs/home',
    //   title: 'PFM - Online Investments - FAQs - Home'
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'FAQs - Landing Screen'
    // })
  },

  onQuestionClick: (question: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `FAQs - Landing Screen - Question - ${question}`
    // })
  },

  onBackClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'FAQs - Landing Screen - Back'
    // })
  }
})

export default faq;
